<template>
  <div class="select_input_box">
    <div class="select_input" :class="isactive?'input_one_active':''">
      <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
      <el-input
        v-model="backVal.FullName"
        size="mini"
        :clearable="true"
        class="input_sty"
        @focus="doFocus"
        @blur="doBlur"
        :disabled="isdisable"
        @dblclick.native="searchClick"
        @clear="clearData"
        @input="regrexp"
      ></el-input>
      <i class="el-icon-plus icon_sty" v-if="permissions1" @click="addClick"></i>
      <i class="el-icon-search icon_sty" v-if="permissions2" @click="searchClick"></i>
    </div>
    <!-- 添加经手人选择弹出框 -->
    <addCustomDialog
      :show.sync="addShow"
      v-if="popType==0"
      fieldData="backVal"
      @backData="backData"
      v-bind="$attrs"
    />
    <!-- 添加仓库弹出框 -->
    <addDalog
      :show.sync="addShow"
      v-if="popType==1"
      fieldData="backVal"
      @backData="backData"
      v-bind="$attrs"
    />
    <!-- 添加经手人选择弹出框 -->
    <addClerkDialog
      :show.sync="addShow"
      v-if="popType==2"
      fieldData="backVal"
      @backData="backData"
      v-bind="$attrs"
    />
    <!-- 添加地区选择弹出框 -->
    <addAreaDalog
      :show.sync="addShow"
      v-if="popType==3"
      fieldData="backVal"
      @backData="backData"
      v-bind="$attrs"
    />
    <!-- 商品选择弹出框 -->
    <!-- <SearchGoodsDialog v-else-if="popType==5" :show.sync="seaechGoodsShow" @chooseGoodsBack="chooseGoodsBack" v-bind="$attrs"/> -->
    <!-- 银行收索弹出框 -->
    <SearchBankDialog
      v-if="popType==6"
      :show.sync="searchShow"
      fieldData="backVal"
      :searchData="searchData"
      @dbclickRow="chooseBack"
      v-bind="$attrs"
    />
    <!-- 部门和地区弹出框 地区3、部门4 -->
    <SearchBankDialog v-else-if="popType== 3 || popType== 4"
      :show.sync="searchShow"
      fieldData="backVal"
      :searchData="searchData"
      @dbclickRow="chooseBack"
      v-bind="$attrs"
    />
    <!-- 科目弹框 -->
    <SearchSubjectDialog v-else-if="popType== 5"
      :show.sync="searchShow"
      fieldData="backVal"
      :searchData="searchData"
      @dbclickRow="chooseBack"
      v-bind="$attrs"
    />
    <!-- 收索弹出框 -->
    <searchClerkDialog
      v-else
      :show.sync="searchShow"
      fieldData="backVal"
      :searchData="searchData"
      @dbclickRow="chooseBack"
      v-bind="$attrs"
    />
  </div>
</template>

<script>

export default {
  name: "SelectInput",
  data() {
    return {
      isactive: false, //是否聚焦状态
      addShow: false, //新增弹出框是否显示
      searchShow: false, //收索弹出框是否显示
      backVal: this.value, //数据
      //传入弹出框的参数 url1：初始化树状图url、url2：初始化表格url、url3：点击收索url、
      // type：查询的数据类型 0商品单位 1商品颜色 2商品尺码 3商品厂家4 账户、
      // interface：判断那种收索框0-9
      searchData: {
        title: "",
        url1: "",
        url2: "",
        url3: "",
        type: "",
        interface: 0
      },
      dataLink: {}
    };
  },
  methods: {
    // 正则验证input
    regrexp(val) {
      this.backVal.FullName = "";
      this.backVal.KtypeId = Number("");
    },
    // 聚焦事件
    doFocus() {
      this.$emit("clickFocus");
      this.isactive = true;
    },
    // 失焦事件
    doBlur() {
      this.$emit("Blur");
      this.isactive = false;
    },
    // 点击input新增icon
    addClick() {
      this.addShow = true;
    },
    // 点击input收索icon
    searchClick() {
      this.searchShow = true;
    },
    //弹出框回填数据
    backData(data, fieidName) {
      let typeId = data.KtypeId || data.BtypeId || data.EtypeId;
      this[fieidName].FullName = data.FullName;
      this[fieidName].KtypeId = typeId;
      this.$emit("changeVal", this.fieldData);
    },
    //弹出框双击选择回填数据
    chooseBack(data, fieidName, typeId) {
      this[fieidName].FullName = data.FullName;
      this[fieidName].KtypeId = typeId;
      this.$emit("changeVal", this.fieldData);
    },
    // 点击input清除数数符号
    clearData() {
      this.backVal.FullName = "";
      this.backVal.KtypeId = Number("");
    }
  },
  props: {
    // 是否显示新增
    permissions1: {
      type: Boolean,
      default: true
    },
    // 是否显示收索
    permissions2: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    // 默认数据值
    value: [String, Object],
    // lable名称
    name: {
      type: String,
      default: "客户"
    },
    // 是否必填
    isMust: {
      type: Boolean,
      default: true
    },
    // input是否可填
    isdisable: {
      type: Boolean,
      default: false
    },
    // 传入的外部字段，将用于传出识别
    fieldData: { type: String },
    // 新增弹出框类型值（0：客户类（单位）、1：仓库类、2：经手人类（职员）、3：地区、4：部门类、5：商品类、6：银行类）
    popType: {
      type: Number
    }
  },
  watch: {
    value:{
        handler(newValue, oldValue) {
          this.backVal = newValue;
        },
        deep: true,
        immediate:true
    }
  },
  created() {
    switch (this.popType) {
      case 0:
        // 客户
        this.searchData = {
          title: "客户/供应商",
          url1: "/index/Client/getlist",
          url2: "/index/Client/getAll",
          url3: "/index/Client/search",
          type: "",
          interface: 0
        };

        break;
      case 1:
        // 仓库
        this.searchData = {
          title: "仓库",
          url1: "/index/Stock/getlist",
          url2: "/index/Stock/getAll",
          url3: "/index/Stock/search",
          type: "",
          interface: 1
        };
        break;
      case 2:
        // 经手人
        this.searchData = {
          title: "经手人",
          url1: "/index/Department/getlist",
          url2: "/index/Person/getAll",
          url3: "/index/Person/search",
          type: "",
          interface: 2
        };
        break;
      case 3:
        // 地区
        this.searchData = {
          title: "地区",
          url1: "/index/Area/getlist",
          url2: "/index/Area/getAll",
          url3: "/index/Area/search",
          type: "",
          interface: 3
        };
        break;
      case 4:
        // 部门
        this.searchData = {
          title: "部门",
          url1: "/index/Department/getlist",
          url2: "/index/Department/getAll",
          url3: "/index/Department/search",
          type: "",
          interface: 4
        };
        break;
      case 5:
        // 科目
        this.searchData = {
          title:'科目',
          url1:'/index/Subject/getlist',
          url2:'/index/Subject/getAll',
          url3:'/index/Subject/search',
          type:'',
          interface:5
        }
        break;
      case 6:
        // 银行账户
        this.searchData = {
          title: "银行账户",
          url1: "",
          url2: "/index/Settings/get_other",
          url3: "/index/Settings/search_other",
          type: 4,
          interface: 6
        };
        break;
      case 7:
        // 商品单位
        // this.searchData = {title:'商品单位',url1:'',url2:'',url3:'',type:0,interface:7}
        break;
      case 8:
        // 商品颜色
        // this.searchData = {title:'商品颜色',url1:'',url2:'',url3:'',type:1,interface:8}
        break;
      case 9:
        // 商品尺码
        // this.searchData = {title:'商品尺码',url1:'',url2:'/',url3:'',type:2,interface:9}
        break;
      case 10:
        // 商品厂家
        // this.searchData = {title:'商品厂家',url1:'',url2:'',url3:'',type:3,interface:10}
        break;
      default:
        break;
    }
  }
};
</script>

<style lang="less">
.select_input_box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  .select_input {
    width: 100%;
    height: 30px;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    color: #000;
    border: 1px solid #d6e2ed;
    border-radius: 5px;
    padding: 0 5px;
    box-sizing: border-box;
    overflow: hidden;
    .label_name {
      height: 100%;
      line-height: 30px;
      font-size: 12px;
      color: inherit;
      font-weight: bold;
    }
    span,
    .label_name {
      display: block;
    }
    .isMust::after {
      content: "*";
      color: red;
    }
    .input_sty {
      position: relative;
      -webkit-box-flex: 1;
      box-flex: 1;
      display: block;
      height: 100%;
    }
    .el-input__inner {
      height: 28px;
      padding: 0;
      padding-left: 6px;
    }
    .el-input__inner,
    .el-input__inner:hover {
      border-color: #fff;
    }
    .icon_sty {
      margin: 0 3px;
      cursor: pointer;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #fff;
    color: #333;
  }
  .input_one:hover {
    border-color: #2594ff;
    color: #2594ff;
  }
  .input_one_active {
    border-color: #2594ff !important;
    color: #2594ff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/SelectInput/SelectInput.vue